<template>
<div class="MStepOne">
    <div class="content_warp">
        <div class="type_box">
            <div class="row_box">
                <p class="title_text">公司名称</p>
                <van-field v-model="formParams.companyname" placeholder="请输入" />
            </div>
            <div class="row_box">
                <p class="title_text">注册资本<img @click="tipsClick('注册资本', '注册资本默认为公司总股本')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formParams.regcapital" type="number" maxlength="8" placeholder="请填写公司注册资本"><template #button><span>万元</span></template></van-field>
            </div>
        </div>
    </div>
    <div @click="nextStepClick" :class="{'btn_box': true}">下一步</div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
import $ from 'jquery'
export default {
    name: 'MStepOne',
    props: ['formParams'],
    data() {
        return {}
    },
    mounted() {
        $('html').scrollTop(0)
    },
    methods: {
        // 显示对应提示弹窗 及标题和内容
        tipsClick(tit, des) {
            this.$emit('setTipsPopInfo', tit, des)
        },
        // 点击下一步
        nextStepClick() {
            if (!this.user.isLogin) {
                // 如果没登录  跳转到登录页面
                this.$router.push({name: 'MLogin'})
            } else {
                if (this.formParams.companyname.length === 0 || this.formParams.companyname.length === '') {
                    Toast('请填写公司名称')
                } else if (this.formParams.regcapital.length === 0) {
                    Toast('请填写公司注册资本')
                } else if (this.formParams.regcapital < 1 || this.formParams.regcapital > 10000000) {
                    Toast('注册资本为 1 - 10000000 万元之间')
                } else if (!/^[0-9]+\.{0,1}[0-9]{0,2}$/.test(this.formParams.regcapital)) {
                    Toast('注册资本为两位小数内的整数')
                } else {
                    // console.log(this.formParams)
                    this.$emit('setStepValue', 1)
                }
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepOne {
    padding-bottom: 0.8rem;
    .btn_box {
        font-size: 0.32rem;
        width: 100vw;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #409EFF;
        color: #FFF;
    }
    .disable_btn {
        background-color: #94C2F1;
    }
}
</style>